export const TOKEN_SEARCH_PARAM_NAME = 'token';
